/**
 * Created by vaibhav on 31/3/18
 */
import React from 'react'
import PropTypes from 'prop-types'
import {kebabCase} from 'lodash'
import Link from 'gatsby-link'
import Content, {HTMLContent} from '../components/Content'
import SE0 from "../components/SEO";
import config from "../../meta/config";
import Share from "../components/Share";
import PartnerNavBar from "../components/PartnerNavBar";




export const PartnerTemplate = ({
                                     content,
                                     contentComponent,
                                     cover,
                                     meta_title,
                                     meta_desc,
                                     tags,
                                     title,
                                     username,
                                     slug,
                                 }) => {
    const PostContent = contentComponent || Content;

    return (
        <section className="section">
            <SE0
                title={title}
                meta_title={meta_title}
                meta_desc={meta_desc}
                cover={cover}
                slug={slug}
                username={username}
            />
            <PartnerNavBar username = {username} />
            <div className="container content">
                <div className="columns">
                    <div className="column is-10 is-offset-1">
                        <h1 className="title is-size-2 has-text-weight-bold is-bold-light">
                            {title}
                        </h1>
                        
                        
<div class="tile is-ancestor">
  <div class="tile is-parent">
    <article class="tile is-child box">
    
      <div class="columns">
  <div class="column is-three-fifths">
    <p class="title">Signed Up</p>
  </div>
  <div class="column">
    <p class="title">225</p>
  </div>
  </div>
      <progress class="progress is-success is-small" value="60" max="100">225</progress>
    </article>
  </div>
  <div class="tile is-parent">
    <article class="tile is-child box">
      <div class="columns">
  <div class="column is-three-fifths">
    <p class="title">In Progress</p>
  </div>
  <div class="column">
    <p class="title">51</p>
  </div>
  </div>
      <progress class="progress is-success is-small" value="15" max="100">20%</progress>
    </article>
  </div>

</div>
<div class="tile is-ancestor">                  

  <div class="tile is-parent">
    <article class="tile is-child box">
    <div class="columns">
  <div class="column is-three-fifths">
    <p class="title">CO2 Avoided</p>
  </div>
  <div class="column">
    <p class="title">60%</p>
  </div>
  </div>
      
     <progress class="progress is-success is-small" value="60" max="100">60%</progress>
    </article>
  </div>
  <div class="tile is-parent">
    <article class="tile is-child box">
          <div class="columns">
  <div class="column is-three-fifths">
    <p class="title">CO2 Avoided</p>
  </div>
  <div class="column">
    <p class="title">60%</p>
  </div>
  </div>
      <progress class="progress is-success is-small" value="60" max="100">60%</progress>
    </article>
  </div>
  </div>
                        
                        
                        <hr/>
                        <Share
                            title={title}
                            slug={slug}
                            excerpt={meta_desc}
                        />
                        <hr/>
                    </div>
                </div>

            </div>
            <form name="contact" netlify>
  <p>
    <label>Name <input type="text" name="name" /></label>
  </p>
  <p>
    <label>Email <input type="email" name="email" /></label>
  </p>
  <p>
    <button type="submit">Send</button>
  </p>
</form>
        </section>
    )
};

PartnerTemplate.propTypes = {
    content: PropTypes.string.isRequired,
    contentComponent: PropTypes.func,
    cover: PropTypes.string,
    meta_title: PropTypes.string,
    meta_desc: PropTypes.string,
    title: PropTypes.string,
    slug: PropTypes.string,
    username: PropTypes.string,
};

const PartnerPage = ({data}) => {
    const {markdownRemark: post} = data;
    return (
        <PartnerTemplate
            content={post.html}
            contentComponent={HTMLContent}
            cover={post.frontmatter.cover}
            meta_title={post.frontmatter.meta_title}
            meta_desc={post.frontmatter.meta_description}
            tags={post.frontmatter.tags}
            title={post.frontmatter.title}
            slug={post.fields.slug}
            username={post.frontmatter.username}
        />
    )
};

PartnerPage.propTypes = {
    data: PropTypes.shape({
        markdownRemark: PropTypes.object,
    }),
};

export default PartnerPage;

export const pageQuery = graphql`
  query PartnerByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      fields {
            slug
          }
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
        cover
        meta_title
        meta_description
        username
        tags
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/partner-page.js